export const API_ENDPOINTS = {
  SUPPORT: {
    Ordering: 'support/ordering/{model}',
  },
};
